import { PackageSecurityServerAssignmentGridSchema } from '../types';
import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';

export class PackageSecurityServerAssignmentGridDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'UnifiedEndpoints';
  private SVALimit = 2000;

  public async getDataForView(companyId: string): Promise<PackageSecurityServerAssignmentGridSchema> {
    return ConsoleRequest.createRequest<PackageSecurityServerAssignmentGridSchema>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        companyId: companyId,
        page: 1,
        limit: this.SVALimit,
      },
      endpoint: this.endpoint,
      method: 'getSvaMachines',
    });
  }

  public async updateSVAMachines(records: Array<PackageSecurityServerAssignmentGridSchema>): Promise<boolean> {
    try {
      return await ConsoleRequest.createRequest<boolean>({
        dataProviderType: DataProviderType.CORE,
        payload: {
          records: records,
        },
        endpoint: this.endpoint,
        method: 'updateSvaMachines',
      });
    } catch (e) {
      return false;
    }
  }
}
